import { QuitInfo } from '@/mobile/types/api/mypage/mobileQuitInfo';
import { atom } from 'recoil';

// 解約可否と回収候補日時を同一 state にまとめ、通常解約・MNP・レンタル WiFi 判定の起点にする。
// eslint-disable-next-line import/prefer-default-export
export const QuitInfoState = atom<QuitInfo>({
  key: 'QuitInfoState',
  default: {
    can_display: false,
    can_quit_normal: false,
    can_quit_mnp: false,
    can_quit_rental_wifi: false,
    quit_schedule_date: '',
    collection_hope_date: [],
    collection_hope_timezone: [],
    contract_type: '',
    price_plan_code: '',
  },
});
